<template>
  <BaseModal :value="true" class="cancel-order" @input="$emit('close')">
    <template v-slot:header>
      <h1>Cancel Order</h1>
    </template>
    <div v-if="saving">
      <div class="flex flex-row justify-center">
        <div class="lds-dual-ring"></div>
      </div>
      <div class="flex flex-row justify-center">
        <p>Cancelling order...</p>
      </div>
    </div>
    <div v-else class="rounded-md flex flex-col justify-center">
      <label for="search">Cancel Reason</label>
      <textarea
        id="search"
        class="bordered regular full h-32"
        placeholder="code or description"
        v-model="reason"
        rows="6"
      ></textarea>
      <div class="flex flex-row justify-end mt-4 gap-2">
        <button class="btn btn-error-button" @click="confirm">
          Cancel Order
        </button>
        <button class="btn btn-dark-button" @click="closeModal">
          Close
        </button>
      </div>
    </div>
  </BaseModal>
</template>
<script>
export default {
  data() {
    return {
      reason: ""
    };
  },
  props: {
    saving: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    confirm() {
      this.$emit("proceedCancelOrder", this.reason);
    }
  }
};
</script>
<style>
.cancel-order .modal-content {
  width: 90% !important;
  max-width: 400px !important;
  height: auto !important;
}
</style>
